/**
 * How long IS a review, in the one unit both the site's Function and the
 * bot's own store agree on -- moved here in V2-4c, per the coordinator's own
 * instruction (`docs/reports/V2-4b.md` §11.2's closing line: "V2-4c's
 * FinishPanel counter is the next caller").
 *
 * Previously this lived only in `site/functions/api/watch/_requestBody.js`,
 * which is the platform's own Cloudflare Pages Function -- reachable from
 * the SERVER side of a request, never from the browser bundle. The
 * FinishPanel's own character counter runs IN the browser, so it needs the
 * identical rule available from a module BOTH sides can import -- CLAUDE.md
 * gotcha 21 ("two implementations of one contract... asserted against each
 * other, never assumed to agree"), the same shape V2-4b round 2 already
 * fixed once (the bot's `len()` counts Unicode CODE POINTS; a naive JS
 * `.length` counts UTF-16 CODE UNITS, and the two diverge for anything
 * outside the Basic Multilingual Plane -- most emoji, which need a
 * surrogate pair). `_requestBody.js` now imports both names from here
 * instead of defining them -- see that file's own header.
 *
 * Zero dependencies, deliberately -- `_requestBody.js` runs as a Cloudflare
 * Pages Function (the Workers runtime, not Node and not a browser), and
 * `FinishPanel.jsx` runs in React. Both accept a plain, dependency-free ES
 * module; neither would accept one that reached for `react` or a Node
 * built-in.
 */

/** `[...text]` iterates a string through the string ITERATOR protocol,
 * which yields one element per Unicode code point (a surrogate pair reads
 * as one) -- matching Python's `len()` exactly. A plain `.length` would
 * count 500 emoji as 1000. */
export function reviewCodePointLength(text) {
  return [...text].length
}

export const REVIEW_MAX_CHARS = 500

/**
 * `text` truncated to at most `max` CODE POINTS -- never a naive
 * `.slice(0, max)`, which cuts by UTF-16 code unit and can sever a
 * surrogate pair in half (turning one emoji into two invalid, unpaired
 * code units). The design prototype's own `onReview` handler does exactly
 * that naive slice (`e.target.value.slice(0, 500)`) -- copied as prose,
 * not as code: see `docs/reports/V2-4c.md`.
 *
 * Returns `text` unchanged when it is already within the limit (the common
 * case), so callers never pay the `[...text]` spread cost while typing an
 * ordinary short review.
 */
export function truncateToCodePoints(text, max) {
  if (reviewCodePointLength(text) <= max) return text
  return [...text].slice(0, max).join('')
}
